export var Experiments = {
    UnreadMessagesButtonDesktop: 'specs.chat.UnreadMessagesButtonDesktop',
    AllowSMSImages: 'specs.chat.AllowSMSImages',
    WidgetRedesignPhase1: 'specs.chat.WidgetRedesignPhase1',
    AllowFullNameLocalization: 'specs.chat.InboxAllowFullNameLocalization',
    InstagramIntegration: 'specs.chat.AllowInstagramDeliveryMethod',
    AllowStarConversations: 'specs.chat.InboxAllowStarConversations',
    InboxAttachments: 'specs.chat.InboxAttachments',
    HideBlackOnBlackBorder: 'specs.chat.HideBlackOnBlackBorder',
};
//# sourceMappingURL=experiments.js.map